const smConversion = {
  50: {
    rank: 99,
    score: 140,
    class: 'very superior',
  },
  49: {
    rank: 99,
    score: 139,
    class: 'very superior',
  },
  48: {
    rank: 99,
    score: 136,
    class: 'very superior',
  },
  47: {
    rank: 99,
    score: 135,
    class: 'very superior',
  },
  46: {
    rank: 98,
    score: 132,
    class: 'very superior',
  },
  45: {
    rank: 98,
    score: 129,
    class: 'superior',
  },
  44: {
    rank: 97,
    score: 128,
    class: 'superior',
  },
  43: {
    rank: 95,
    score: 125,
    class: 'superior',
  },
  42: {
    rank: 94,
    score: 123,
    class: 'superior',
  },
  41: {
    rank: 92,
    score: 121,
    class: 'superior',
  },
  40: {
    rank: 90,
    score: 119,
    class: 'high average',
  },
  39: {
    rank: 87,
    score: 117,
    class: 'high average',
  },
  38: {
    rank: 84,
    score: 115,
    class: 'high average',
  },
  37: {
    rank: 81,
    score: 113,
    class: 'high average',
  },
  36: {
    rank: 77,
    score: 111,
    class: 'high average',
  },
  35: {
    rank: 70,
    score: 108,
    class: 'average',
  },
  34: {
    rank: 63,
    score: 105,
    class: 'average',
  },
  33: {
    rank: 58,
    score: 103,
    class: 'average',
  },
  32: {
    rank: 53,
    score: 101,
    class: 'average',
  },
  31: {
    rank: 47,
    score: 99,
    class: 'average',
  },
  30: {
    rank: 42,
    score: 97,
    class: 'average',
  },
  29: {
    rank: 37,
    score: 95,
    class: 'average',
  },
  28: {
    rank: 32,
    score: 93,
    class: 'average',
  },
  27: {
    rank: 25,
    score: 90,
    class: 'average',
  },
  26: {
    rank: 21,
    score: 88,
    class: 'low average',
  },
  25: {
    rank: 18,
    score: 86,
    class: 'low average',
  },
  24: {
    rank: 14,
    score: 84,
    class: 'low average',
  },
  23: {
    rank: 12,
    score: 82,
    class: 'low average',
  },
  22: {
    rank: 9,
    score: 80,
    class: 'low average',
  },
  21: {
    rank: 6,
    score: 77,
    class: 'below average',
  },
  20: {
    rank: 5,
    score: 75,
    class: 'below average',
  },
  19: {
    rank: 3,
    score: 72,
    class: 'below average',
  },
  18: {
    rank: 2,
    score: 70,
    class: 'below average',
  },
  17: {
    rank: 2,
    score: 68,
    class: 'well below average',
  },
  16: {
    rank: 1,
    score: 67,
    class: 'well below average',
  },
  15: {
    rank: 1,
    score: 64,
    class: 'well below average',
  },
  14: {
    rank: 1,
    score: 62,
    class: 'well below average',
  },
  13: {
    rank: 1,
    score: 60,
    class: 'well below average',
  },
  12: {
    rank: 1,
    score: 58,
    class: 'well below average',
  },
  11: {
    rank: 1,
    score: 56,
    class: 'well below average',
  },
  10: {
    rank: 1,
    score: 54,
    class: 'well below average',
  },
  9: {
    rank: 1,
    score: 51,
    class: 'well below average',
  },
  8: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  7: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  6: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  5: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  4: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  3: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  2: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  1: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  0: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
};

export default smConversion;
